export const PATH_COMMUNITY_TEMPLATES = 'communitytemplates/';
export const PATH_SERVICES = 'openapiservices/';
export const PATH_USERS = 'users/';
